/**
 * Column keys shared by the service-item grids (`service-case-order-job-items` and
 * `service-case-order-items`) and read by host-side helpers (bulk work-item
 * selection/actions, T20-128140 / T20-138767). Part of the wire contract with the grid
 * definitions — see PREDEFINED_COLUMNS in JobItemsDataGrid / OrderItemsDataGrid and the
 * backend definitions; a renamed column must be updated here or the helpers silently
 * match nothing (getRowCellValue returns undefined for absent columns).
 */
export const SERVICE_ITEMS_GRID_COLUMNS = {
  itemType: 'itemType',
  serviceOrderJobItemId: 'serviceOrderJobItemId',
  serviceJobId: 'serviceJobId',
  assignMechanics: 'assignMechanics',
} as const;
